export const ru = {
    clicks: 'Всего кликов',
    cost: 'Общий расход',
    ctr: 'средний CTR',
    shows: 'Всего показов'
};
